<template>
	<div id="security_index_edu">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<div v-on:click="screen()"><dv-decoration-9 :color="['#55ffff', '#0090ff']" class="full_screen">{{ screenName }}</dv-decoration-9></div>
				<!-- 第一行标题装饰条 -->
				<div class="d-flex jc-center title_bg"></div>
				<!-- 数据开始 -->
				<div class="safe_left" style="display: block;">
					<div class="campus_safetit"><img src="../../assets/img/school_icon.png"><b>选择学校</b>（点击列表可查看）</div>
					<!-- <div class="search" style="max-width:300px">
						<input type="text" placeholder="输入学校名称搜索" name="search">
						<button type="submit"></button>
					</div> -->
					<div class="line_bg" style="max-width:300px"></div>
					<ul>
						<li :class="activeClass1 == index ? 'on' : ''" v-for="(org, index) in orgList" :key="index" @click="changeOrg(index, org.orgId)">{{ org.orgName }}</li>
					</ul>
				</div>
				<!-- 右边开始 -->
				<div class="safe_right">
					<div class="campus_safetit"><img src="../../assets/img/camera_icon.png"><b>录像设备</b>（点击列表可查看）</div>
					<div class="line_bg" style="max-width:300px"></div>
					<ul>
						<li :class="activeClass2 == index ? 'on' : ''" v-for="(device, index) in securityList" :key="index" @click="openView(index, device.lanAddress, device.lanPort)">{{ device.deviceName }}</li>
					</ul>
				</div>
			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
var storage = window.localStorage;
var region = storage.getItem("region");
var orgCode = storage.getItem("orgCode");
export default {
	data() {
		return {
			loading: true,
			fullscreen: false,
			screenName: "全屏",
			orgList: [],
			securityList: [],
			activeClass1: 0,
			activeClass2: 0
		};
	},
	mounted() {
		this.cancelLoading();
		this.initData();
	},
	methods: {
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		initData() {
			let _this = this;
			var type = this.$route.query.type;
			//判断访问客户端类型
			if (type == 'window') {
				_this.screenName = "全屏";
			} else {
				_this.screenName = "返回";
			}
			this.$http.get("/dataView/security/getOrgListBySecurity?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					if (result.length > 0) {
						_this.orgList = result;
						this.loadDevice(result[0].orgId);
					}
				}
			});
		},
		loadDevice(orgId) {
			let _this = this;
			this.$http.get("/dataView/security/getSecurityInfo?orgId=" + orgId).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					if (result.length > 0) {
						_this.securityList = result;
					}
				}
			});
		},
		//切换学校
		changeOrg(index, orgId) {
			this.activeClass1 = index;
			this.loadDevice(orgId);
		},
		//打开观看端画面
		openView(index, pubAddress, pubPort) {
			this.activeClass2 = index;
			window.open('http://' + pubAddress + ':' + pubPort, '_blank');
		},
		//点击全屏
		screen: function () {
			var type = this.$route.query.type;
			//判断访问客户端类型
			if (type == 'window') {
				let _this = this;
				let element = document.documentElement;
				if (_this.fullscreen) {
					if (document.exitFullscreen) {
						document.exitFullscreen();
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
					}
					_this.screenName = "全屏";
				} else {
					if (element.requestFullscreen) {
						element.requestFullscreen();
					} else if (element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen();
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen();
					} else if (element.msRequestFullscreen) {
						element.msRequestFullscreen();
					}
					_this.screenName = "取消";
				}
				_this.fullscreen = !_this.fullscreen;
			}else{
				//window.AndroidWebView.finish();
				this.$router.replace('/dataView/appIndex?area=' + region);
			}
		}
	},
	// 注意在vue实例销毁前，清除我们的定时器。
	destroyed() {
		if (this.timer) {
			clearInterval(this.timer)
		}
	}
};
</script>

<style lang="scss">
#security_index_edu {
	background-color: #181b37;
	width: 100%;
	min-height: 100vh;
	background-image: url("../../assets/img/campussafe_bg.jpg");
	background-size: 100% 100%;

	.full_screen {
		width: 0.8rem;
		height: 0.8rem;
		position: absolute;
		top: 0.32rem;
		right: 0.5rem;
		font-size: 0.2rem;
		color: #55ffff;
		font-weight: bold;
		-webkit-background-clip: text;
		background-image: linear-gradient(90deg, #55ffff, #55aaff);
		-webkit-text-fill-color: transparent;
		cursor: pointer;
	}

	.bg {
		padding: 0.2rem 0.2rem 0 0.2rem;
		background-position: center center;
	}

	.title_bg {
		width: 100%;
		height: 10vh;
		background: url("../../assets/img/campussafe_titbg.png") center no-repeat;
	}

	.search input[type=text] {
		width: 3rem;
		height: 0.5rem;
		padding-left: 0.2rem;
		font-size: 0.2rem;
		border: 2px solid #55ffff;
		float: left;
		color: #55ffff;
		background: none;
	}

	.search input:-moz-placeholder {
		color: #55ffff;
	}

	.search input:-ms-input-placeholder {
		color: #55ffff;
	}

	.search input::-webkit-input-placeholder {
		color: #55ffff;
	}

	.search button {
		float: left;
		width: 0.5rem;
		height: 0.5rem;
		padding: 10px;
		border: 2px solid #55ffff;
		background: #266bff url("../../assets/img/search_icon.png") center no-repeat;
		background-size: 50%;
		border-left: none;
		cursor: pointer;
	}

	.search button:hover {
		border: 2px solid #4599ff;
		background: #4599ff url("../../assets/img/search_icon.png") center no-repeat;
		background-size: 50%;
		border-left: none;
	}

	.search::after {
		content: "";
		clear: both;
		display: table;
	}

	.line_bg {
		height: 0.03rem;
		background-image: linear-gradient(to right, rgba(0, 240, 244, 0.6), rgba(33, 209, 244, 0.3), rgba(0, 240, 244, 0));
		margin: 0.2rem 0;
	}

	.campus_safetit {
		font-size: 0.18rem;
		color: #55ffff;
		margin-bottom: 0.2rem;
	}

	.campus_safetit b {
		font-size: 0.25rem;
	}

	.campus_safetit img {
		width: 0.3rem;
		margin-right: 0.05rem;
		vertical-align: middle;
	}

	.safe_left {
		float: left;
		margin: 0.3rem 0 0 1rem;
	}

	.safe_left ul {
		height: 65vh;
		overflow-y: auto;
	}

	.safe_left ul li {
		width: fit-content;
		padding: 0.1rem 0.2rem;
		margin: 0 0 0.2rem 0;
		position: relative;
		color: #55ffff;
		font-size: 0.22rem;
		border-left: 3px solid #55ffff;
		background-image: linear-gradient(to right, rgba(33, 209, 244, 0.6), rgba(0, 240, 244, 0.2), rgba(0, 240, 244, 0));
	}

	.safe_left ul li:hover,
	.safe_left ul li.on {
		background-image: linear-gradient(to right, rgba(31, 141, 244, 0.6), rgba(179, 103, 244, 0.4), rgba(41, 105, 244, 0.0));
		border-right: 3px solid #55ffff;
	}

	.safe_left ul li:hover,
	.safe_right ul li:hover {
		cursor: pointer;
	}

	.safe_left ul::-webkit-scrollbar {
		width: 2px;
	}

	.safe_left ul::-webkit-scrollbar-thumb {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(16, 221, 191, 0.1), rgba(27, 118, 103, 0.1), rgba(20, 195, 221, 0.1));
	}

	.safe_left ul::-webkit-scrollbar-track {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(20, 195, 221, 0), rgba(11, 252, 252, 0.1), rgba(20, 195, 221, 0));
	}

	.safe_right ul::-webkit-scrollbar {
		width: 2px;
	}

	.safe_right ul::-webkit-scrollbar-thumb {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(16, 221, 191, 0.1), rgba(27, 118, 103, 0.1), rgba(20, 195, 221, 0.1));
	}

	.safe_right ul::-webkit-scrollbar-track {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(20, 195, 221, 0), rgba(11, 252, 252, 0.1), rgba(20, 195, 221, 0));
	}

	//下方区域的布局
	.safe_right {
		padding: 0 0 0 0.2rem;
		float: right;
		margin: 0.3rem 1rem 0 0;
	}

	.safe_right ul {
		height: 65vh;
		overflow-y: auto;
	}

	.safe_right ul li {
		width: fit-content;
		max-width: 3rem;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		padding: 0.1rem 0.2rem;
		position: relative;
		color: #00fff7;
		font-size: 0.22rem;
		border-radius: 2rem;
		margin: 0 0 0.2rem 0;
		border-bottom: 1px solid rgba(0, 213, 255, 0.2);
		box-shadow: 0px 0px 10px #55ffff inset;
	}

	.safe_right ul li:hover,.safe_right ul li.on {
		background-image: linear-gradient(to right, rgba(123, 63, 244, 0.8), rgba(42, 52, 244, 0.8));
		box-shadow: 0px 0px 1px #55ffff inset;
	}
}</style>